import React from 'react';

import { SkeletonImage } from '@xingternal/skeleton';

import styles from './Skeleton.css';

const Skeleton = () => (
  <div data-testid="locations-skeleton">
    <SkeletonImage variant="primary" amountRows={3} className={styles.map} />
  </div>
);

export default Skeleton;
